import React from "react";
import { Container } from "./styled/checkbox-label";

function CheckboxLabel(props) {
  return <Container {...props} />;
}

export default CheckboxLabel;
